module.exports = __webpack_public_path__ + "img/header-illustration@3x.cb7d88f2.png";